import { slideContextFactory } from '../../../../components/slides/slideContextFactory';
import { ISlide, SlideProps } from '../../../../components/slides/SlideTypes';
import { AssessmentOtherSlideProps } from '../../../../content/assessment/components/AssessmentSlideTypes';

export type SurveySlideProps = SlideProps<AssessmentOtherSlideProps>;
export type SurveySlide = ISlide<AssessmentOtherSlideProps>;

export const { SlideProvider: SurveySlideProvider, useSlideContext: useSurveySlideContext } =
  slideContextFactory<SurveySlide>();
